export const fullSizecontainer = {
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'center',
  alignItems: 'center',

  width: '100%',
  height: '100%',
};
